import { PropsWithChildren } from 'react';

interface GrayedOutProps {
  gray?: boolean;
  className?: string;
}

const GrayedOut: React.FC<PropsWithChildren<GrayedOutProps>> = ({
  gray = true,
  className = '',
  children,
}) => {
  return (
    <div className={`relative ${className}`}>
      {children}
      {gray && <div className="absolute inset-0 z-10 bg-white bg-opacity-50" />}
    </div>
  );
};

export default GrayedOut;
